import { compter, diffLignes, replier } from "@/lib/diff";

export function Diff({ avant, apres }: { avant: string; apres: string }) {
  const lignes = diffLignes(avant, apres);
  const { ajouts, retraits } = compter(lignes);
  if (!ajouts && !retraits) return <p className="discret">Aucun changement.</p>;
  return (
    <div className="diff">
      <div className="diff-entete">
        <span className="ajout">+{ajouts}</span> <span className="retrait">−{retraits}</span>
      </div>
      <pre>
        {replier(lignes).map((m, i) =>
          m.genre === "replie" ? (
            <div key={i} className="diff-replie">
              … {m.n} ligne{m.n > 1 ? "s" : ""} inchangée{m.n > 1 ? "s" : ""} …
            </div>
          ) : (
            <div key={i} className={`diff-${m.genre}`}>
              <span className="diff-marque">{m.genre === "ajout" ? "+" : m.genre === "retrait" ? "−" : " "}</span>
              {m.texte || " "}
            </div>
          ),
        )}
      </pre>
    </div>
  );
}
